import axios from "axios";
const state = () => ({
    form: {},
    item: {},
    items: {},
    loadingForm:true,
    loadingItem:true
});
const actions = {
    async sendFormUnLimited({ dispatch, commit }, info) {
        commit('SET_LOADING', true)
        await axios
            .post(`${ info.api}`, info.form)
            .then(res => {
                // let resultData = res.data.data;
                this._vm.$toast.success("operation accomplished successfully");

            })
            .catch(err => {
                dispatch('fetchTableData', info)
                this._vm.$toast.error("The operation failed"
                );

            })

    },
    async sendForm({ dispatch, commit }, info) {
        commit('SET_LOADING', true)
        await axios
            .post(`${ !info.isNew ?  info.api.edit : info.api.create}`, info.form)
            .then(res => {
               // let resultData = res.data.data;
                dispatch('fetchTableData', info)
                this._vm.$toast.success("operation accomplished successfully");

            })
            .catch(err => {
                dispatch('fetchTableData', info)
                this._vm.$toast.error("The operation failed"
                );

            })

    },
    async sendFormMakePay({ dispatch, commit }, info) {
        commit('SET_LOADING', true)
        await axios
            .post(`${ info.api.pay }`, info.form)
            .then(res => {
               // let resultData = res.data.data;
                dispatch('fetchTableData', info)
                this._vm.$toast.success("operation accomplished successfully");

            })
            .catch(err => {
                dispatch('fetchTableData', info)
                this._vm.$toast.error("The operation failed"
                );

            })

    },

    async sendMakePay({ dispatch, commit }, info) {
        commit('SET_LOADING', true)
        await axios
            .post(`${ info.api.pay }`, info.form)
            .then(res => {
                // let resultData = res.data.data;
                dispatch('fetchTableData', info)
                this._vm.$toast.success("operation accomplished successfully");

            })
            .catch(err => {
                dispatch('fetchTableData', info)
                this._vm.$toast.error("The operation failed"
                );

            })

    },

    async createTransaction({ dispatch, commit }, info) {
        commit('SET_LOADING', true)
        await axios
            .post(`${ info.api.createTransaction }`, info.form)
            .then(res => {
                // let resultData = res.data.data;
                dispatch('fetchTableData', info)
                this._vm.$toast.success("operation accomplished successfully");

            })
            .catch(err => {
                dispatch('fetchTableData', info)
                this._vm.$toast.error("The operation failed"
                );

            })

    },
    async sendFormOrder({ dispatch, commit }, info) {
        commit('SET_LOADING', true)
        await axios
            .post(`${info.id == null ? info.api[info.opoperation] : info.api.edit +  '/'+ info.id }`, info.form)
            .then(res => {
               // let resultData = res.data.data;
               console.log(info);
                dispatch('fetchTableData', info)
                this._vm.$toast.success("operation accomplished successfully");

            })
            .catch(err => {
                console.log(err);
                dispatch('fetchTableData', info)
                this._vm.$toast.error("The operation failed"
                );

            })

    },
    async fetchForm({ commit }, api) {
        commit('SET_LOADING', true)
        await axios
            .get(`${ api}`)
            .then(res => {
                let resultData = res.data.data;
                if(Array.isArray(resultData)){
                    commit("SET_FORM",resultData[0])
                }else{
                    commit("SET_FORM",resultData)
                }
                commit('SET_LOADING', false)

            })
            .catch(err => {
                commit('SET_LOADING', false)
            })

    },
    async fetchItem({ commit }, api) {
        commit('SET_LOADING_ITEM', true)
        await axios
            .get(`${ api}`)
            .then(res => {
                let resultData = res.data.data;
                if(Array.isArray(resultData)){
                    commit("SET_ITEM",resultData[0])
                }else{
                    commit("SET_ITEM",resultData)
                }
                commit('SET_LOADING_ITEM', false)
            })
            .catch(err => {
                commit('SET_LOADING_ITEM', false)
            })

    },
    async fetchItems({ commit }, api) {
        commit('SET_LOADING_ITEMS', true)
        await axios
            .get(`${ api}`)
            .then(res => {
                let resultData = res.data.data;

                if(Array.isArray(resultData)){
                    commit("SET_ITEMS",resultData)
                }else{
                    commit("SET_ITEMS",resultData)
                }
                commit('SET_LOADING_ITEMS', false)
            })
            .catch(err => {
                commit('SET_LOADING_ITEMS', false)
            })
    },

    setForm({ commit }, form) {
        commit('SET_FORM', form)
    },
    initForm({ commit }, init_form) {
        commit('SET_INIT_FORM', init_form)
    },

}

const getters = {
    getForm: state => {
        return state.form
    },
    getItem: state => {
        return state.item
    },
    getItems: state => {
        return state.items
    },
    getLoadingForm: state => {
        return state.loadingForm
    },
    getLoadingItem: state => {
        return state.loadingItem
    },
}

const mutations = {
    SET_TABLE_DATA(state, payload) {
        state.tableData = payload
    },
    SET_FORM(state, payload) {
        let temp_form = state.form
        let t
        for (t in temp_form) {
            state.form[t] = payload[t]
        }
    },
    SET_ITEM(state, payload) {
        state.item = payload
    },
    SET_ITEMS(state, payload) {
        state.items = payload
    },
    SET_INIT_FORM(state, payload) {
        state.form = payload
    },
    SET_LOADING(state, payload) {
        state.loadingForm = payload
    },
    SET_LOADING_ITEM(state, payload) {
        state.loadingItem = payload
    },
    SET_LOADING_ITEMS(state, payload) {
        state.loadingItems = payload
    },

}


export default {
    state,
    getters,
    mutations,
    actions
}
